import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { fetchReviewQueue, type ReviewQueueFilter } from '../lib/queries';
import { PageHeader, QueryState } from '../components/ui';
import { ReviewQueueTable } from '../components/ReviewQueueTable';

const FILTERS: Array<{ key: ReviewQueueFilter; label: string; empty: string }> = [
  { key: 'todas', label: 'Todas', empty: 'No hay actividades esperando revisión.' },
  { key: 'mias', label: 'Mías', empty: 'No tiene revisiones asignadas. Tome una de la lista «Sin asignar».' },
  { key: 'sin_asignar', label: 'Sin asignar', empty: 'No hay revisiones libres en este momento.' },
];

/** La cola de trabajo del revisor: todo lo que esta EN_REVISION dentro de su alcance, vencidas primero. */
export function ReviewQueue() {
  const [filter, setFilter] = useState<ReviewQueueFilter>('todas');
  const q = useQuery({ queryKey: ['review', 'queue', filter], queryFn: () => fetchReviewQueue(filter) });
  const current = FILTERS.find((f) => f.key === filter)!;

  return (
    <>
      <PageHeader
        eyebrow="Revisión"
        title="Bandeja de revisión"
        sub="Actividades enviadas a revisión. Tome una para que otra persona no la revise a la vez."
        actions={
          <Link className="btn" to="/revision">
            Tablero del revisor
          </Link>
        }
      />
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        {FILTERS.map((f) => (
          <button
            key={f.key}
            className={f.key === filter ? 'btn btn--primary' : 'btn btn--ghost'}
            aria-pressed={f.key === filter}
            onClick={() => setFilter(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>
      <div className="card">
        <div className="card__b">
          <QueryState isLoading={q.isLoading} error={q.error}>
            <ReviewQueueTable rows={q.data ?? []} emptyText={current.empty} />
          </QueryState>
        </div>
      </div>
    </>
  );
}
